module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-09-16 at 12.11.54 PM (1).5102dd8b.jpeg";